// src/hooks/useStreak.ts
// Convenience hook: returns the current display streak and quietly forces a
// re-render every 60s so that midnight rollovers (which break a streak) update
// the UI without requiring a manual refresh.

import { useEffect, useState } from 'react';
import { useStreakStore } from '../stores/useStreakStore';
import { computeDisplayStreak } from '../services/streakService';

/** Returns the user-facing streak count, kept fresh through day rollovers. */
export function useStreak(): number {
  const record = useStreakStore((s) => s.record);
  const [, forceTick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => forceTick((t) => t + 1), 60_000);
    return () => window.clearInterval(id);
  }, []);

  return computeDisplayStreak(record);
}